// extracted by mini-css-extract-plugin
export default {"video":"video_video__Vm9zD","shape":"video_shape__jc0i0","icon":"video_icon__wni86"};